import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Devotionals from "./components/Devotionals";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Navbar />
      <main>
        <Hero />
        <Devotionals />
      </main>
      <Footer />
    </div>
  );
}
